import React from 'react';
import Configurer from '../../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import FormViewer from '../../../components/FormViewer';
import LoaderButton from '../../../components/LoaderButton';
import StagesManager from '../../../components/StagesManager';
import TLink from '../../../components/TLink';
import HttpServices from '../../../utils/Http.services';
import { checkTranslation, invoiceStatusConvertor, pathMaker, priceStandardView, translate } from '../../../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { withRouter } from "react-router-dom";
import PageStatusViewer from '../../../components/PageStatusViewer';
import Collapsible from 'react-collapsible';
import TableViewer from '../../../components/TableViewer';
import moment from 'jalali-moment';
import ReactToPrint from 'react-to-print';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';

class AccountingPayment extends React.Component {

    state = {

        paymentValues: {},

        customerHeader: [
            { key: 'customer', type: 'SelectInput', col: '12', information: { label: '{{lang}}Customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'hub.fullname', image: 'hub.image', value: 'hub._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: true }, showMain: false },
        ],

        paymentsHeaders: [
            { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}Invoice date', placeholder: '{{lang}}Invoice date', required: true }, showMain: true },
            { key: 'number', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
            { key: 'mode', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Payment mode', required: true, type: 'local', default: '0', items: [{ title: "{{lang}}Cash", value: 'C', color: '#789' }, { title: "{{lang}}Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'amount', type: 'PriceInput', col: '12', information: { label: '{{lang}}amount', placeholder: '{{lang}}amount', required: false, disabled: true }, showMain: true },

        ],


        invoiceHeaders: [
            { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}Invoice date', placeholder: '{{lang}}Invoice date', required: true }, showMain: true },
            { key: 'id', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
            // { key: 'mode', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Payment mode', required: true, type: 'local', default: '0', items: [{ title: "{{lang}}Cash", value: 'C', color: '#789' }, { title: "{{lang}}Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'amounts.totals.final', type: 'PriceInput', col: '12', information: { label: '{{lang}}Invoice Amount', placeholder: '{{lang}}Invoice Amount', required: false, disabled: true }, showMain: true },
            { key: 'balanceDue', type: 'PriceInput', col: '12', information: { label: '{{lang}}Amount Due', placeholder: '{{lang}}Amount Due', required: false, disabled: false }, showMain: true },
            { key: 'payment', type: 'PriceInput', col: '12', information: { label: '{{lang}}Payment', placeholder: '{{lang}}Payment', required: false, disabled: false, inplaceEditable: true, changeFunction: 'paymentValueChanged' }, showMain: true },
        ],


        invoiceViewHeaders: [
            { key: 'id', type: 'TextInput', col: '12', information: { label: '{{lang}}Invoice Number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
            { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}Invoice date', placeholder: '{{lang}}Invoice date', required: true }, showMain: true },
            // { key: 'mode', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Payment mode', required: true, type: 'local', default: '0', items: [{ title: "{{lang}}Cash", value: 'C', color: '#789' }, { title: "{{lang}}Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'amounts.totals.final', type: 'PriceInput', col: '12', information: { label: '{{lang}}Invoice Amount', placeholder: '{{lang}}Invoice Amount', required: false, disabled: true }, showMain: true },
            { key: 'payment', type: 'PriceInput', col: '12', information: { label: '{{lang}}Payment Amount', placeholder: '{{lang}}payment', required: false, disabled: false }, showMain: true },
        ],

        paymentsData: []

    }

    componentDidMount() {

        let _id = this.props.windowData?.path[this.props.baseUrl?.length]
        this.setState({ _id })
        if (_id != "new" && _id != null) {

            this.fetch(_id)

        } else {
            this.stageManager.changeStage('edit')
        }


        if (this.props.setHeader) {
            this.props.setHeader({
                // 'toolbar': this.toolbarComponent,
                'showToolbar': true,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.changePage('payments')

            })
        }


    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.postPayment}
                    title='Save'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>
        )
    }


    fetch = (id) => {

        this.setState({ isLoading: true, errors: {} })
        //         data.applet = this.props.applet._id
        if (this.state.payment?._id) {
            id = this.state.payment?._id
        }

        HttpServices.request("getPayment", { id }, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                // cb(false, fetchError.message)
                // this.setState({ error: fetchError.message })
                this.setState({ pageStatus: 404 })

                return
            }

            if (fetchResult.info) {

                this.setState({ customerIsSelected: true, customer: fetchResult.info.customer })
                // this.fetchInvoices()

                this.setState({ payment: fetchResult.info, pageStatus: 200 }, () => {
                    this.stageManager.changeStage('view')
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                })

                let paymentinvoices = []

                if (Array.isArray(fetchResult.info.list)) {
                    fetchResult.info.list.forEach(element => {
                        // element.payment = element.amount
                        paymentinvoices.push({ ...element.invoice, ...{ payment: element.amount } })
                    });
                }


                this.setState({ paymentinvoices }, () => { })

                // console.log(fetchResult.info)
                // this.stageManager.nextStage()
            }

        })

        //     }
        // }
    }


    postPayment = () => {
        // this.setState({ isLoading: true, errors: {} })
        // console.log("postPayment")
        if (this.form) {
            // let customer = this.customerForm.getForm()?.customer
            let data = this.form.getForm()
            // console.log(data)
            // console.log(data)
            if (data) {

                // if (((this.state.payment?.amount ?? 0) - (this.state.paymentValues['*'] ?? 0)) != 0) {
                //     // this.setState({'error'})
                // }
                if (!data.amount || data.amount == 0 || data.amount == '') {
                    this.setState({ errors: { amount: '{{lang}}errors.required' } })
                    return
                }

                // data.customer = customer
                this.setState({ isLoadingPost: true, errors: {} })
                data.applet = this.props.applet._id
                data.appletHub = typeof this.props.variables.appletHub == 'object' ? this.props.variables.appletHub._id : this.props.variables.appletHub
                data.totalPaymentAmount = this.state.paymentValues['*']
                // let list = []

                // for (const [key, value] of Object.entries(this.state.paymentValues)) {
                //     if (key != '*' && value != null && value != 0 && value != '') {
                //         list.push({ invoice: this.state.invoices[key]?._id, amount: value })
                //     }
                // }

                // data.list = list

                let address = "postPayment"

                if (data._id) {
                    address = "editPayment"
                }

                data.type = "invoice_payment"

                // console.log(address)
                // console.log('dataaaaaaaaaaaaaaaaapaymenteeeeeeeeeee', data)
                // return
                HttpServices.request(address, data, (fetchResult, fetchError) => {

                    this.setState({ isLoadingPost: false })

                    if (fetchError) {
                        this.setState({ error: fetchError.message })
                        // console.log("fetchError", fetchError)
                        return
                    }

                    // console.log(fetchResult.info)
                    if (fetchResult.info) {

                        // console.log("fetchResult success", fetchResult)
                        this.setState({ success: true, payment: fetchResult.info }, () => {
                            this.stageManager.changeStage('view')
                        })


                        let paymentinvoices = []

                        if (Array.isArray(fetchResult.info.list)) {
                            fetchResult.info.list.forEach(element => {
                                paymentinvoices.push({ ...element.invoice, ...{ payment: element.amount } })
                            });
                        }


                        this.setState({ paymentinvoices }, () => { })




                        if (this.state._id == 'new' || this.state._id == null) {
                            let newLink = this.props.baseUrl.splice(2)
                            newLink.push(fetchResult?.info?._id)

                            this.props.changeWindowLink(newLink)
                            this.setState({ _id: fetchResult?.info?._id, })
                        }
                        // let newPath = window.location.pathname + window.location.search
                        // if (!window.location.search || window.location.search == '') {
                        //     newPath = newPath + "?id=" + fetchResult.info._id
                        // } else {
                        //     newPath = newPath + "&id=" + fetchResult.info._id
                        // }
                        // window.history.pushState(null, null, pathMaker(newPath));

                        // window.history.pushState(null, null, pathMaker('/editor/' + fetchResult.name));


                    }

                })

            }
        }
    }


    fetchInvoices = () => {
        // console.log("fetchinvoices")
        this.setState({ isLoading: true, fullAmount: null, invoices: [], paymentValues: {}, errors: {} })
        //         data.applet = this.props.applet._id
        if (this.state.customer) {
            let customer = this.state.customer

            let paymentInvoices = []

            // console.log(this.state.payment)

            if (this.state.payment?.list) {
                this.state.payment.list.forEach(element => {
                    // console.log(element)
                    paymentInvoices.push((typeof element.invoice == 'object' ? element.invoice._id : element.invoice))
                });
            }


            HttpServices.request("getCustomerPendingInvoices", { applet: this.props.variables?.appletId, customer, invoices: paymentInvoices }, (fetchResult, fetchError) => {

                this.setState({ isLoading: false })
                // console.log(fetchResult)
                // console.log(fetchError)

                if (fetchError) {
                    // console.log("HERE")
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                if (fetchResult.info) {

                    let fullAmount = 0
                    if (Array.isArray(fetchResult.info)) {

                        for (let i = 0; i < fetchResult.info.length; i++) {
                            const invoice = fetchResult.info[i]
                            let invoiceAmount = 0

                            if (paymentInvoices.includes(invoice._id)) {
                                if (this.state.payment?.list) {
                                    this.state.payment.list.forEach(element => {

                                        let id = typeof element.invoice == 'object' ? element.invoice._id : element.invoice
                                        if (id == invoice._id) {
                                            invoiceAmount = element.amount
                                        }
                                    });
                                }

                                invoice.balanceDue = invoice.balanceDue + invoiceAmount
                            }

                            fullAmount = fullAmount + (invoice.balanceDue ?? 0)


                        }

                    }


                    let invoices = [...fetchResult.info]
                    let paymentValues = {}
                    paymentValues['*'] = 0

                    if (Array.isArray(this.state.payment?.list)) {

                        this.state.payment.list.forEach((element, index) => {
                            invoices.forEach(invoice => {
                                let id = typeof element.invoice == 'object' ? element.invoice._id : element.invoice
                                if (invoice._id == id) {
                                    paymentValues[index] = element.amount
                                    paymentValues['*'] = paymentValues['*'] + element.amount
                                    invoice.payment = element.amount
                                }
                            });



                            // paymentinvoices.push({ ...element.invoice, ...{ payment: element.amount } })
                        });


                    }


                    this.setState({ paymentValues, invoices, fullAmount }, () => {

                    })
                }

            })
        }


    }

    customerliveChange = (data, init, key) => {
        // console.log(data)
        let payment = { ...this.state.payment }
        if (!payment) {
            payment = {}
        }

        // console.log(this.state.customer)
        // console.log(data.customer)

        if (key == 'customer' && this.state.customer != data.customer) {
            let customer = data.customer
            payment.customer = customer
            this.setState({ payment, customer }, () => {
                if (customer) {
                    this.setState({ customerIsSelected: true })
                    this.fetchInvoices()
                } else {
                    this.setState({ customerIsSelected: false, invoices: [] })

                }
            })
        }
    }

    liveChange = (fullData, init, key, value, extra) => {
        // console.log("liveChange")
        if (!init) {
            let amount = 0
            if (key == 'amount' || key == null) {
                amount = fullData["amount"]
                this.amountChanged(amount, null)
            }
        }
        // console.log(fullData)

    }


    changeReceiveFullAmount = (e) => {
        let checked = e.target.checked
        // console.log(checked)
        let payment = { ...this.state.payment }
        if (!payment) {
            payment = {}
        }

        if (checked) {
            payment.amount = Number(this.state.fullAmount)
        } else {
            payment.amount = 0
        }
        // console.log(payment.amount)

        this.setState({}, () => {
            this.amountChanged(payment.amount, !checked)
        })
    }


    amountChanged(amount, clear) {
        // console.log("amountChanged")
        // console.log(amount)
        let remained = amount
        if (!remained) {
            remained = 0
        }
        let paymentValues = {}
        let invoices = this.state.invoices ? JSON.parse(JSON.stringify(this.state.invoices)) : []

        if (Array.isArray(invoices)) {

            for (let i = 0; i < invoices.length; i++) {

                const invoice = invoices[i];
                if (clear) {
                    paymentValues[i] = 0
                } else {
                    if (invoice.balanceDue <= remained) {
                        paymentValues[i] = invoice.balanceDue ?? 0
                    } else {
                        paymentValues[i] = remained ?? 0
                    }
                    remained = remained - Number((paymentValues[i] ?? 0))
                }
                invoices[i].payment = paymentValues[i] ?? 0

            }

        }

        // console.log(paymentValues)
        // console.log(invoices)

        for (const [key, value] of Object.entries(paymentValues)) {

            if (!paymentValues['*']) {
                paymentValues['*'] = 0
            }

            paymentValues['*'] = paymentValues['*'] + value
        }

        // console.log(paymentValues)
        let payment = this.state.payment ? JSON.parse(JSON.stringify(this.state.payment)) : {}

        // if (!payment) {
        //     payment = {}
        // }

        payment.amount = amount
        if (!payment.amount) {
            payment.amount = 0
        }
        // console.log(invoices)
        // console.log(payment)


        // console.log(this.state.fullAmount)
        // console.log(amount)
        // console.log(payment)
        // console.log(paymentValues)



        this.setState({ paymentValues, invoices, payment })
        // if(amount )


        // console.log(amount == this.state.fullAmount)


        this.receiveFullAmount.checked = (amount == this.state.fullAmount)

        // this.setState({receiveFullAmount})
    }

    cancel = () => {
        if (this.state.payment?._id) {
            this.fetch()
        } else {

            let search = this.props.location.search;
            let params = new URLSearchParams(search);
            let ref = params.get('ref');
            if (ref && ref !== '') {
                // console.log(ref)
                this.props.history.push(ref)
            } else {
                this.props.history.goBack()
            }
        }
    }

    functionsHandler = (type, name, data, extra, cb) => {

        // functionsHandler = (reference, key, data, extra, index) => {
        console.log(type, name, data, extra, cb)
        if (this[name]) {
            // this[name](key, data, extra, index, reference)
            this[name](data, extra, cb)
        }
    }


    paymentValueChanged = (data, extra) => {
        let invoices = this.state.invoices
        invoices[extra.index].payment = data

        let paymentValues = this.state.paymentValues
        if (!paymentValues) {
            paymentValues = {}
        }

        let oldValue = paymentValues[extra?.index]
        paymentValues[extra?.index] = data


        if (!paymentValues['*']) {
            paymentValues['*'] = 0
        }
        // console.log(value - (oldValue ?? 0))

        paymentValues['*'] = paymentValues['*'] + (data - (oldValue ?? 0))
        // }

        this.setState({ paymentValues, invoices })

        // console.log("paymentValueChanged")
    }


    // calcFullAmount(){
    //     if(Array.isArray(this.state.invoices))
    // }





    render() {
        let excess = (this.state.payment?.amount ?? 0) - (this.state.paymentValues['*'] ?? 0)
        return (


            <section className="h-100  w-100  scroll-no-scrollbar flexc flex-column" style={{ backgroundColor: '#f0f0f0' }}>
                <div className='w-100 mt-4 br-10 mb-5' style={{ maxWidth: 800, backgroundColor: '#fff' }}>


                    <div className="w-100 pt-0 px-3 " style={{ borderRadius: '0px 0px 0px 0px' }}>
                        {/* <div className="w-100 pb-4 pt-5 px-5 " style={{ backgroundImage: 'linear-gradient(to left bottom, #ee5050,#dd5070', borderRadius: '0px 0px 0px 0px' }}> */}

                        <div className="w-100">

                            {!this.state.payment?._id && (
                                <>
                                    <div className="flexc col-12 col-md-6">
                                        {/* <div className="mrd-4 flexcc">
                                                <img src={'/images/icons/' + this.props.applet?.type + ".svg"} style={{ border: '3px solid #ffffff50', height: 80, width: 80, objectFit: 'cover', borderRadius: '50%', border: '1px solid #eeeeee10', boxShadow: '0px 0px 15px #00000020' }} />
                                                <img src={'/images/icons/products.svg'} style={{ border: '3px solid #ffffff50', height: 80, width: 80, objectFit: 'cover', borderRadius: '50%', border: '1px solid #eeeeee10', boxShadow: '0px 0px 15px #00000020' }} />

                                            </div> */}
                                        <div>
                                            {/* <TLink to={'/' + (this.props.applet?.user?.username ?? ('p/' + this.props.applet?.user?._id))} >
                                                    <p className="text-normal mt-1" style={{ color: '#ffffffdd' }}>{this.props.applet?.user?.fullname}</p>
                                                </TLink> */}

                                            {/* <h1 className="text-big text-bold" style={{ color: '#fff' }}>{translate("New Payment")}</h1> */}

                                            {/* <p className="mt-1 text-smaller" style={{ color: '#ffffffdd' }}>{this.props.applet?.name}</p> */}
                                        </div>
                                    </div>

                                    {/* <div className="flexc col-12 col-md-6 d-flex justify-content-md-end mt-4 mt-md-0">
                                            <div className=" d-flex " style={{ boxShadow: '0px 0px 30px #00000020', backgroundColor: '#ffffffee', borderRadius: 15, padding: '16px 26px' }}>

                                                <div>

                                                    <div className="  w-100 flexcc flex-column">
                                                        <span className="text-bold  text-big">{this.state.payment?.list?.total ? priceStandardView(this.state.payment?.list?.total) : 0}</span>
                                                        <p className="text-small ">Total Price</p>
                                                        <p className="text-smaller opacity-5 ">Create Invoice Stage</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                </>
                            )}


                            {this.state.payment?._id && (
                                <div className='w-100'>
                                    <div className='d-flex w-100'>
                                        <div className="flexc col-12 col-md-6">
                                            {/* <div className="mrd-4 flexcc">
                                                    <img src={'/images/icons/products.svg'} style={{ border: '3px solid #ffffff50', height: 50, width: 50, objectFit: 'cover', borderRadius: '50%', border: '1px solid #eeeeee10', boxShadow: '0px 0px 15px #00000020' }} />
                                                </div> */}
                                            <div>
                                                <TLink to={'/' + (this.props.applet?.user?.username ?? ('p/' + this.props.applet?.user?._id))} >
                                                    <p className="text-normal mt-1" style={{ color: '#ffffffdd' }}>{checkTranslation(this.props.applet?.user?.fullname)}</p>
                                                </TLink>

                                                <h1 className="text-ultra-big text-bold" style={{ color: '#fff' }}>{"# " + this.state.payment?.number}</h1>

                                                {/* <p className="mt-1 text-smaller" style={{ color: '#ffffffdd' }}>{this.props.applet?.name}</p> */}
                                            </div>
                                        </div>

                                        <div className="flexc col-12 col-md-6 d-flex justify-content-md-end mt-4 mt-md-0">
                                            <div className=" d-flex " style={{ background: invoiceStatusConvertor(this.state.payment?.status)?.background, borderRadius: 6, padding: '6px 20px' }}>

                                                <div>
                                                    {/* {console.log(this.state.payment)} */}

                                                    <div className="  w-100 flexcc flex-column">
                                                        <span className="text-bold  text-big text-uppercase" style={{ color: invoiceStatusConvertor(this.state.payment?.status)?.color, }}>{checkTranslation(invoiceStatusConvertor(this.state.payment?.status)?.title)}</span>
                                                        {/* <p className="text-small ">Status</p> */}
                                                        {/* <p className="text-smaller opacity-5 ">Create Invoice Stage</p> */}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 mt-1 flexc py-1" style={{ color: '#fff', padding: '0px 10px', backgroundColor: 'rgba(0,0,0,0.2)' }}>

                                        <button onClick={() => { this.stageManager.changeStage('edit'); window.scrollTo({ top: 0, behavior: 'smooth' }) }} className="flexc text-white text-small prd-2" ><img className="mrd-2" src="/assets/icons/edit.png" height="18px" />{translate('edit')}</button>
                                        <button className="flexc text-white text-small px-2" ><img className="mrd-2" src="/assets/icons/share2.png" height="18px" />{translate('share')}</button>
                                        {/* <button className="flexc text-small px-2" ><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('PDF/Print')}</button> */}
                                        <div>
                                            <ReactToPrint
                                                trigger={() => {
                                                    return <button className="flexc text-white text-small px-2" ><img className="mrd-2" src="/assets/icons/printer.png" height="20px" />{translate('PDF/Print')}</button>

                                                }}
                                                content={() => this.printRef}
                                                documentTitle='Invoice'
                                                pageStyle="pdf"
                                                onAfterPrint={() => console.log('document prited')}
                                            />
                                        </div>

                                    </div>
                                </div>
                            )}




                        </div>
                    </div>
                    <div className="pt-0 w-100 " style={{ margin: '0px 0px', position: 'relative', }}>


                        <StagesManager ref={el => this.stageManager = el} fast={true}>


                            <div stage={1} stageName={'view'} className="p-0 pb-5 d-flex flex-column w-100" style={{}}>
                                <div className="w-100 flexc" style={{ color: '#789', padding: '0px 20px', borderRadius: '0px 0px 0px 0px' }}>

                                    {/* <button onClick={() => { this.stageManager.changeStage('edit'); this.fetchInvoices(); window.scrollTo({ top: 0, behavior: 'smooth' }) }} className="flexc text-normal py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('edit')}</button>
                                        <button className="flexc text-normal py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('share')}</button>
                                        <button className="flexc text-normal py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('PDF/Print')}</button> */}

                                </div>

                                <div className="">
                                    {/* {this.state.paymentsData?.length ? (
                                            <div className="px-3" style={{ border: '1px solid #eee', borderRadius: 8 }}>
                                                <div className="flexcb w-100 cursor-pointer py-3" onClick={() => this.setState({ showPayments: !this.state.showPayments })}>
                                                    <div className="flexc">
                                                        <p className="text-bold text-small">{translate('Payments Received')} </p>
                                                        <span className="flexcc text-small white mx-2" style={{ backgroundColor: '#007aff', borderRadius: 18, height: 18, minWidth: 18 }}>{this.state.paymentsData?.length}</span>
                                                    </div>

                                                    <img className={"opacity-5" + (this.state.showPayments ? ' rotate-90' : '')} src="/images/arrow-a.svg" height="12px" style={{ transition: '0.5s' }} />
                                                </div>
                                                <Collapsible open={this.state.showPayments}>
                                                    <div className="pb-3 pt-0" >
                                                        <TableViewer headers={this.state.paymentsHeaders} data={this.state.paymentsData} top={0} />
                                                    </div>
                                                </Collapsible>
                                            </div>
                                        ) : (

                                            <div className="px-3" style={{ border: '1px solid #eee', borderRadius: 8 }}>
                                                <div className="flexcb w-100 py-3" onClick={() => this.setState({ showPayments: !this.state.showPayments })}>
                                                    <div className="flexc">
                                                        <img src="/images/shield.svg" height="40px" />
                                                        <div className="mld-3">
                                                            <p className="text-bold text-normal">{translate('Faster with online payment gateways')} </p>
                                                            <p style={{ color: '#789' }} className="text-small mt-1">{translate('Set up a payment gateway and start accepting payments online')} </p>

                                                        </div>
                                                    </div>
                                                    <button className="py-2 px-2" style={{ backgroundColor: 'rgb(103, 125, 196)', borderRadius: 8 }}>
                                                        <p className="white text-small">Submit Payment</p>
                                                    </button>
                                                </div>

                                            </div>

                                        )} */}

                                    <div className="d-flex mb-5" style={{ justifyContent: 'center' }}>
                                        <div className="mt-4 w-100 mb-5" style={{}}>
                                            <div className="px-5 py-4">
                                                <div className='d-flex justify-content-between pb-4 mb-4' style={{ borderBottom: '1px solid #eee' }}>
                                                    <div>
                                                        <p className="text-small"># {this.state.payment?.number}</p>
                                                        <p>{checkTranslation(this.state.payment?.customer?.fullname)}</p>



                                                    </div>

                                                    <div>
                                                        <p className="text-big">{translate('Payment Receipt'.toLowerCase())}</p>

                                                        {/* <p className="text-small mt-3">{translate('Balance Due')}</p> */}
                                                        {/* <p className="text-normal mt-1">{priceStandardView(this.state.payment?.balanceDue)}</p> */}

                                                    </div>
                                                </div>

                                                <div className="flexc mt-3">
                                                    <div className="w-100 mrd-4">
                                                        <div className="flexcb pb-2 mb-2" style={{ borderBottom: '1px solid #f2f6f8' }}>
                                                            <p className="text-small ">{translate('Payment Date')}</p>
                                                            {moment(this.state.payment?.date).isValid() && (
                                                                <p className="text-normal mt-1">{moment(this.state.payment?.date).local('fa').format('YYYY/MM/DD')}</p>
                                                            )}
                                                        </div>

                                                        <div className="flexcb pb-2 mb-2" style={{ borderBottom: '1px solid #f2f6f8' }}>
                                                            <p className="text-small ">{translate('Payment Mode')}</p>
                                                            {moment(this.state.payment?.mode).isValid() && (
                                                                <p className="text-normal mt-1">{checkTranslation(this.state.payment?.mode)}</p>
                                                            )}
                                                        </div>


                                                    </div>

                                                    <div className="flexcc flex-column white mld-4 py-3" style={{ minWidth: 150, border: '1px solid rgb(0, 205, 116)', borderRadius: 4 }}>
                                                        <p className="text-bold color-black text-semibig mb-0">{priceStandardView(this.state.payment?.amount)}</p>
                                                        <p className="text-small color-black">{translate("Amount Received")}</p>

                                                    </div>

                                                </div>

                                                <div className="mt-5">
                                                    <p className="mb-2 text-bold">{translate("Payment for")}</p>
                                                    <TableViewer headers={this.state.invoiceViewHeaders} data={this.state.paymentinvoices} top={0} actions={null} functionsHandler={this.functionsHandler} />

                                                </div>


                                                <div className="mt-3">
                                                    <p className="text-small mb-2">{translate('Note')}</p>
                                                    <p>{checkTranslation(this.state.payment?.description)}</p>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div stage={1} stageName={'edit'} className="col-12 p-0 pb-5 flexc flex-column " style={{}}>

                                <div className="w-100 flexc flex-column pt-4" style={{ padding: '0px 2%' }}>


                                    {/* <div className="w-100 mb-3" style={{ padding: '0% 0%' }}>
                                        <FormViewer ref={el => this.customerForm = el} headers={this.state.customerHeader} liveChange={this.customerliveChange} initData={this.state.payment} errors={this.state.errors} inputClass={'modern-input '} variables={this.props.variables} />


                                        <div className={"flexc px-3 mb-2 " + ((this.state.fullAmount != null && this.state.fullAmount != 0) ? "" : 'd-none')}>
                                            <input ref={el => this.receiveFullAmount = el} onChange={(e) => this.changeReceiveFullAmount(e)} id="fullAmount" name="fullAmount" className="" type='checkbox' />
                                            <label for='fullAmount' className="mld-2 text-small" style={{ color: '#007aff', userSelect: 'none' }}>{translate("Receive full amount")} ( {priceStandardView(this.state.fullAmount)} )</label>
                                        </div>


                                        <div className="w-100 mt-1" style={{ borderBottom: '1px solid #eee' }}></div>
                                    </div> */}

                                    <div className="position-relative w-100" style={{ padding: '0% 0%', position: 'relative' }}>

                                        <FormViewer ref={el => this.form = el} headers={this.props.page?.headers} initData={this.state.payment} errors={this.state.errors} inputClass={'bordered-input '} variables={this.props.variables} />



                                        {/* <div className="pb-3 pt-0 px-3" >
                                            <p className="text-big mb-3 px-1">{translate("Unpaid Invoices")}</p>

                                            <TableViewer headers={this.state.invoiceHeaders} data={this.state.invoices} top={0} functionsHandler={this.functionsHandler} />


                                            <div className="d-flex  justify-content-end mt-3 mb-4">
                                                <div className="d-flex" style={{ backgroundColor: '#f6f6f6', borderRadius: 8, padding: '15px 20px' }}>
                                                    <div className="text-center" style={{ maxWidth: '250px', width: '100%', color: '#000' }}>
                                                        <p className="text-small text-end mb-2 text-bold">{translate("Total Payment")}</p>
                                                        <p className="text-small text-end mb-2">{translate("Amount Received")}</p>
                                                       
                                                        <p className="text-small text-end mb-2">{translate("Amount in Excess")}</p>
                                                       


                                                    </div>

                                                    <div className="text-center" style={{ width: '150px' }}>
                                                        <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.paymentValues['*'] ?? 0)}</p>
                                                        <p className="text-small text-end mb-2">{priceStandardView(this.state.payment?.amount ?? 0)}</p>
                                                       
                                                        <p className="text-small text-end mb-2" style={{ color: excess ? '#ee5050' : '#000' }}>{priceStandardView(excess)}</p>
                                                        

                                                    </div>
                                                </div>
                                            </div>


                                        </div> */}

                                        {/* {!this.state.customerIsSelected && (
                                            <div style={{ zIndex: 8, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#ffffff70' }}></div>
                                        )} */}
                                    </div>

                                    {/* <div className="blur-back w-100 flexc " style={{ padding: '5px 3% 5px 3%', position: 'sticky', zIndex: 9, bottom: this.props.settings.isMobile ? 60 : 0, backgroundColor: '#ffffffaa', borderTop: '1px solid #ddd' }}> */}
                                    <div className="px-4 w-100 flexc mb-5" style={{}}>

                                        <div className=" mx-0 w-100">
                                            <div className=" flexc">
                                                <div className="">
                                                    {/* <LoaderButton
                                                        onClick={this.postPayment}
                                                        isLoading={this.state.isLoadingPost}
                                                        text={translate("Submit".toLowerCase()).toUpperCase()}
                                                        type={"Oval"}
                                                        className="my-2 py-1 br-6"
                                                        buttonStyle={{ outline: 'none', background: 'linear-gradient(to left bottom, #ee5050, #c0003a)', cursor: 'pointer', padding: '10px 40px', borderRadius: 20, fontSize: 14, fontWeight: 'bold', color: '#fff', border: 'none' }}
                                                        width={20}
                                                        height={20}
                                                        color={'#fff'}
                                                        background={'linear-gradient(to left bottom, #ee5050, #c0003a)'}

                                                    /> */}

                                                    <ButtonAnimated
                                                        iconwidth='28px'
                                                        isLoading={this.props.isLoadingPost}
                                                        onClick={this.postPayment}
                                                        title='{{lang}}Save'
                                                        icon='/assets/icons/save.svg'
                                                        invert={!this.props.colors?.iconInvert}
                                                        bg={this.props.colors?.background}
                                                        textColor={this.props.colors?.textColor}
                                                    />


                                                </div>
                                                {this.state.invoice?.number && (
                                                    <div className="mld-2">
                                                        <LoaderButton
                                                            onClick={this.cancel}
                                                            isLoading={this.state.isLoading}
                                                            text={translate("Cancel").toUpperCase()}
                                                            type={"Oval"}
                                                            className="mt-2 mb-2"
                                                            buttonStyle={{ outline: 'none', background: 'linear-gradient(to left bottom, #e2e6e8, #e8e9f0', cursor: 'pointer', padding: '8px 40px', borderRadius: 4, fontSize: 14, fontWeight: 'bold', color: '#000', border: 'none' }}
                                                            width={20}
                                                            height={20}
                                                            color={'#202020'}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {/* <div className="col-12 col-md-6 flexc d-none d-md-flex flexc justify-content-end">

                                                    <button className="flexcc" style={{ color: '#007aff' }}>
                                                        <div className="mrd-2 flexcc" style={{ height: 20, width: 20, borderRadius: 20, backgroundColor: '#007aff' }}><img className="invert" src="/images/light-bolt.svg" height="16px" /></div>
                                                        Extra Actions
                                                    </button>
                                                </div> */}
                                        </div>

                                        {/* <button onClick={() => this.props.lastStage()} className="text-small " style={{ color: '#789' }}>Back one stage?</button> */}

                                    </div>
                                </div>
                            </div>






                            <div stage={1} stageName={'success'} className="col-12 pb-5 flexc flex-column" style={{ opacity: this.state.mainOpacity, transition: 'all 0.5s', flex: '1 1 auto', paddingTop: 20 }}>
                                <div className="text-center" style={{ backgroundColor: '#007aff20', color: '#007aff', borderRadius: 8, padding: '20px 40px' }}>
                                    <p className="text-small">{translate('The invoice was registered successfully')}</p>
                                    <button onClick={() => this.stageManager.changeStage('view')} className="mt-2" style={{ backgroundColor: '#007aff', color: '#fff', borderRadius: 20, padding: '5px 20px' }}>{translate('Registration of a new invoice')}</button>
                                </div>
                            </div>


                        </StagesManager>

                    </div>
                </div>
            </section>


        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource, pages: state.pages })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AccountingPayment));